import { render, staticRenderFns } from "./MatchFieldsIssues.vue?vue&type=template&id=175a99ed&scoped=true&"
import script from "./MatchFieldsIssues.vue?vue&type=script&lang=ts&"
export * from "./MatchFieldsIssues.vue?vue&type=script&lang=ts&"
import style0 from "./MatchFieldsIssues.vue?vue&type=style&index=0&id=175a99ed&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175a99ed",
  null
  
)

export default component.exports